import { Card, Stack, UnstyledButton } from "@mantine/core";

import { Group, HelpIcon, Text } from "@/components/ui/elements";

type Props = {
  points: number;
  isForceWithdown: boolean;
  onOpenDetail: () => void;
  onOpenHistory: () => void;
};

export function PointCard({
  points,
  isForceWithdown,
  onOpenDetail,
  onOpenHistory,
}: Props) {
  const getColor = () => {
    if (isForceWithdown && points <= 0) return "red";
    if (points < 5) return "orange";
    return "teal";
  };

  return (
    <Card withBorder p="sm" radius="md">
      <Stack align="center" gap={4}>
        <Group gap="xs" align="center">
          <UnstyledButton onClick={onOpenDetail}>
            <Text fz={20} fw="bold" c={getColor()}>
              {points}pt
            </Text>
          </UnstyledButton>
          <UnstyledButton onClick={onOpenDetail}>
            <HelpIcon color="teal" size={14} />
          </UnstyledButton>
        </Group>
        <Text c="dimmed" fz="xs" fw="bold" ta="center">
          持ち点
        </Text>
        <Group gap="xs" justify="center">
          <UnstyledButton onClick={onOpenDetail}>
            <Text td="underline" c="teal" ta="center" fz="xs">
              詳細
            </Text>
          </UnstyledButton>
          <UnstyledButton onClick={onOpenHistory}>
            <Text td="underline" c="teal" ta="center" fz="xs">
              変動履歴
            </Text>
          </UnstyledButton>
        </Group>
      </Stack>
    </Card>
  );
}
